import { useMemo } from 'react';

export function useNewRegExp(pattern: string | null | undefined) {
  const regExp = useMemo(() => {
    try {
      return pattern ? new RegExp(pattern) : undefined;
    } catch {
      return undefined;
    }
  }, [pattern]);

  return regExp;
}
